import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import { isProfileLoading, isLoggedIn, isLOA3 } from 'platform/user/selectors';
import PropTypes from 'prop-types';
import { focusElement } from 'platform/utilities/ui';
import Inbox from './Inbox';
import AskVaLinkWithRouter from '../components/AskVaLink';
import { CHAPTER_3 } from '../constants';
import BreadCrumbs from '../components/BreadCrumbs';

function InboxPage({ router }) {
  const { userIsAuthorized, userStillLoading } = useSelector(state => ({
    userStillLoading: isProfileLoading(state),
    userIsAuthorized: isLoggedIn(state) && isLOA3(state),
  }));

  useEffect(() => {
    if (!userStillLoading && !userIsAuthorized) {
      router.replace('/');
    }
  }, [router, userStillLoading, userIsAuthorized]);

  useEffect(() => {
    document.title = 'Inbox - Ask VA | Veterans Affairs';
    focusElement('#inbox-title');
  }, []);

  if (userStillLoading) {
    return (
      <va-loading-indicator
        data-testid="loading-indicator"
        message="Loading..."
      />
    );
  }

  return (
    <div id="inbox-page" className="usa-grid">
      <BreadCrumbs currentPath="/inbox" />
      <div id="inbox-header">
        <h1 id="inbox-title" className="vads-u-margin--0">
          Inbox
        </h1>
        <p className="vads-u-margin--0 vads-u-font-size--lg">
          Check the status of your Ask VA questions and review our responses.
        </p>
        <div>
          <AskVaLinkWithRouter
            variant="action"
            text="Ask a new question"
            href={CHAPTER_3.YOUR_PERSONAL_INFORMATION.PATH}
          />
        </div>
      </div>
      <Inbox />
    </div>
  );
}

InboxPage.propTypes = {
  router: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }).isRequired,
};

export default withRouter(InboxPage);
